package com.tovtalk.ui.screen.settings

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.tovtalk.di.koinInject
import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.repository.AppRepository
import com.tovtalk.ui.components.CenteredContentWrapper
import com.tovtalk.ui.platform.TovTalkWebView
import com.tovtalk.ui.scaffold.ScreenScaffold
import com.tovtalk.ui.scaffold.TovTalkTopBar
import com.tovtalk.ui.theme.TovTalkTheme
import com.tovtalk.utils.config.PlatformConfig
import com.tovtalk.utils.strings.StringProvider

private const val PAGE_SLUG = "privacy"

@Composable
fun PrivacyScreen(
    onNavigateBack: () -> Unit,
    appRepository: AppRepository = koinInject()
) {
    val baseUrl = PlatformConfig.getApiBaseUrl().trimEnd('/') + "/api/v2/pages/$PAGE_SLUG"
    var htmlContent by remember { mutableStateOf<String?>(null) }
    var loadError by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        when (val result = appRepository.getPageContent(PAGE_SLUG, "he")) {
            is DomainResult.Success -> htmlContent = result.data
            is DomainResult.Error -> loadError = true
            else -> {}
        }
    }

    ScreenScaffold(
        topBar = {
            TovTalkTopBar(
                title = StringProvider.get("settings_privacy"),
                onBack = onNavigateBack,
            )
        },
        constrainContentWidth = false,
    ) { paddingValues ->
        val privacyContent = @Composable {
        when {
            loadError -> Box(
                modifier = Modifier.fillMaxSize().padding(paddingValues),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = StringProvider.get("common_error") + " – " + StringProvider.get("common_try_again"),
                    style = TovTalkTheme.typography.bodyMedium,
                    color = TovTalkTheme.colors.textSecondary
                )
            }
            htmlContent != null -> TovTalkWebView(
                url = baseUrl,
                modifier = Modifier.fillMaxSize().padding(paddingValues),
                htmlContent = htmlContent
            )
            else -> Box(
                modifier = Modifier.fillMaxSize().padding(paddingValues),
                contentAlignment = Alignment.Center
            ) {
                CircularProgressIndicator(color = TovTalkTheme.colors.brand)
            }
        }
        }
        CenteredContentWrapper { privacyContent() }
    }
}
